import type { RouteRecordRaw } from 'vue-router';
import { AuthRoutes } from '@/types/enums/RouteNameEnums';

export const authRoutes: RouteRecordRaw[] = [
    {
        name: AuthRoutes.Login,
        path: '/login',
        component: () => import('@/views/AppLogin.vue'),
        meta: { requiresAuth: false, pageTitle: 'login' },
    },
    {
        name: AuthRoutes.ForgotPassword,
        path: '/forgot-password',
        component: () => import('@/views/ForgotPasswordView.vue'),
        meta: { requiresAuth: false, pageTitle: 'forgotPassword' },
    },
    {
        name: AuthRoutes.ResetPassword,
        path: '/reset-password',
        component: () => import('@/views/ResetPasswordView.vue'),
        meta: { requiresAuth: false, pageTitle: 'resetPassword' },
        props: route => ({
            token: route.query.token,
            email: route.query.email,
            broker: route.query.broker ?? 'users',
            isCreate: false,
        }),
    },
    {
        name: AuthRoutes.CreatePassword,
        path: '/create-password',
        component: () => import('@/views/ResetPasswordView.vue'),
        meta: { requiresAuth: false, pageTitle: 'createPassword' },
        props: route => ({
            token: route.query.token,
            email: route.query.email,
            isCreate: true,
        }),
    },
    {
        name: AuthRoutes.PrepareDemo,
        path: '/prepare-demo',
        component: () => import('@/views/prepare-demo/PrepareDemoPage.vue'),
        meta: { requiresAuth: false, pageTitle: 'prepareDemo' },
    },
];
